import utils from '@src/common/utils'
import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '任务名称',
        prop: 'planName',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 24,
        align: 'center',
        rules: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ]
      },
      {
        label: '巡检周期',
        prop: 'planCycle',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        placeholder: '请输入巡检周期（天）',
        rules: [
          { required: true, message: '请输入巡检周期', trigger: 'blur' }
        ]
      },
      {
        label: '开始时间',
        prop: 'startTime',
        type: 'date',
        hide: true,
        value: '',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        pickerDisabled: {  //验证时间范围
          disabledDate: (time) => {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        span: 12,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD') : '';
        },
        rules: [
          { required: true, message: '请输入任务名称', trigger: 'change' }
        ]
      },
      {
        label: '截止时间',
        prop: 'endTime',
        type: 'date',
        hide: true,
        value: '',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD') : '';
        },
        rules: [
          { required: true, message: '请输入任务名称', trigger: 'change' }
        ]
      },
      {
        label: '状态',
        prop: 'status',
        type: 'select',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        // formslot: true,
        span: 12,
        viewFormatter: (row, value) => {
          if (Number(value) === 1) {
            return '启用'
          } else if (Number(value) === 2) {
            return '禁用'
          }
          return '';
        },
        dicData: [
          {
            label: '启用',
            value: '1'
          },
          {
            label: '禁用',
            value: '2'
          }
        ],
        align: 'center',
        rules: [
          { required: true, message: '请输入任务名称', trigger: 'change' }
        ]
      },
      {
        label: '巡检范围',
        prop: 'areaList',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: 'center',
        placeholder: '请选择区域',
        rules: [
          { required: true, message: '请输入巡检范围', trigger: 'blur' }
        ]
      },
      {
        label: '巡检人员',
        prop: 'inspectPersonList',
        type: 'select',
        multiple: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        formslot: true,
        span: 24,
        dicData: [],
        rules: [
          { required: true, message: '巡检人员', trigger: 'blur' }
        ],
        formatter: function (row, value) {
          const nameList = []
          if (value && value.length) {
            value.map(item => {
              nameList.push(item.nickName)
            })
          }
          return nameList.toString();
        }
      },
      {
        label: '巡检设备',
        prop: 'fireassetTypeList',
        type: 'select',
        addDisplay: false,
        editDisplay: false,
        overHidden: true,
        align: 'center',
        span: 12,
        formatter: function (row, value) {
          const nameList = []
          if (value && value.length) {
            value.map(item => {
              nameList.push(Dic.findByValue('SENU077', item.fireassetType))
            })
          }
          return nameList.toString();
        },
        rules: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ]
      },

      {
        label: '巡检内容',
        prop: 'fireassetDev',
        type: 'select',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        formslot: true,
        align: 'center',
        span: 24
      },
    ]
  }
}
export default tableOption